<form novalidate #currentForm="ngForm" class="flows-form">
  <div class="title">Flows Definitions</div>
  <table class="dscp-table" mat-table [dataSource]="flowDataSource" class="table">
    <ng-container matColumnDef="flowId">
      <th mat-header-cell *matHeaderCellDef>Flow ID</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div>
          <input
            autocomplete="off"
            type="text"
            class="input-box"
            #flowIdInput="ngModel"
            [(ngModel)]="element.flowId"
            name="flowId{{ i }}"
            (input)="flowIdUpdated(i, element)"
            maxlength="80"
            required
          />
        </div>
        <div
          class="error"
          *ngIf="flowIdInput.invalid && (flowIdInput.dirty || flowIdInput.touched)"
        >
          <mat-error *ngIf="flowIdInput.errors.maxlength">Flow id is too long</mat-error>
          <mat-error *ngIf="flowIdInput.errors.required">Flow id is required</mat-error>
        </div>
        <div *ngIf="element.flowIdExist">
          <mat-error>Flow id already exist</mat-error>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="destinationMac">
      <th mat-header-cell *matHeaderCellDef>Destination MAC</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div>
          <input
            autocomplete="off"
            type="text"
            class="input-box"
            #destinationMacInput="ngModel"
            [(ngModel)]="element.destinationMac"
            name="destinationMac{{ i }}"
            (input)="onDestinationMacAddressChange(destinationMacInput.name, element)"
            [pattern]="macRegex"
            required
          />
        </div>
        <div
          class="error"
          *ngIf="
            destinationMacInput.invalid &&
            (destinationMacInput.dirty || destinationMacInput.touched)
          "
        >
          <mat-error *ngIf="destinationMacInput.errors.required"
            >Destination MAC is required</mat-error
          >
          <mat-error *ngIf="destinationMacInput.errors?.pattern"
            >Mac address is not a valid</mat-error
          >
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="megLevel">
      <th mat-header-cell *matHeaderCellDef>MEG Level</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <select
          class="dropdown"
          #megLevelInput="ngModel"
          name="megLevel{{ i }}"
          [(ngModel)]="element.megLevel"
          (ngModelChange)="onMegLevelChange(element)"
        >
          <option *ngFor="let item of megLevelDropdown" [value]="item">
            {{ item }}
          </option>
        </select>
      </td>
    </ng-container>

    <ng-container matColumnDef="megId">
      <th mat-header-cell *matHeaderCellDef>Performance Monitor</th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div>
          Meg Id: {{ element?.ccm?.ccmPeriod === 'off' ? '--' : element?.attributes?.megId }}
        </div>
        <a class="edit-text" (click)="onClickEdit(element, i)">edit</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="add">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="add-popup"
        (click)="addFlow()"
        [matTooltip]="maxFlowsReached ? 'Maximum flows reached' : ''"
      >
        + Add
      </th>
      <td mat-cell *matCellDef="let element; let i = index">
        <i
          class="mdi mdi-content-copy clone-icon"
          matTooltip="Clone"
          (click)="cloneFlow(element)"
        ></i>
        <i
          class="mdi mdi-close-circle-outline close-circle remove-flow-icon"
          matTooltip="Remove"
          (click)="removeFlow(element, i)"
        ></i>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedFlowsColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedFlowsColumns"></tr>
  </table>
</form>
